import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';


import moment from 'moment';
import 'moment/locale/de';
import ICAL from 'ical.js'


moment.locale('de');

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

let urls = [
  'https://alypius.cassiciacum.de/remote.php/dav/public-calendars/SjnX2XSXTCQceeW9?export',
  'https://alypius.cassiciacum.de/remote.php/dav/public-calendars/9XYPWZgRgCWPi6zz?export',
  'https://alypius.cassiciacum.de/remote.php/dav/public-calendars/LHqgCdS2br2Yk26S?export',
  'https://alypius.cassiciacum.de/remote.php/dav/public-calendars/ZWsk8rEPSQGwpgKN?export',
  'https://alypius.cassiciacum.de/remote.php/dav/public-calendars/fSsMW3arfYB7qMDL?export',
  'https://alypius.cassiciacum.de/remote.php/dav/public-calendars/442tPdcZE9b8LyF3?export',
  'https://alypius.cassiciacum.de/remote.php/dav/public-calendars/kaJfxxXT49zqNTS3?export',
];




const rows = [];

class KalenderTable extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            events: []
        };
    }

    loadData() {
        urls.forEach(url => {
                fetch(url)
                    .then(response => response.text())
                    .then(ics => parseEvents(ics))
                    .then(events => this.setState({events: this.state.events.concat(events)}))
            }
        )
    }

    componentDidMount() {
        this.loadData();
    }


    render() {

        let events = this.state.events.filter(a => a.start.isAfter(moment().startOf('month')));

        events.sort((a,b) => {
            if ( a.start.isBefore(b.start) ) return -1;
            if ( a.start.isAfter(b.start) ) return 1;
            return 0
        });

        const {classes} = this.props;

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Datum</TableCell>
                            <TableCell>Uhrzeit</TableCell>
                            <TableCell>Ort</TableCell>
                            <TableCell>Veranstaltung</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {events.map(row => {

                            let datum = row.start.format("dddd, Do MMMM YYYY");

                            let zeit = row.start.format("HH:mm") + " Uhr";
                            if ( zeit == "00:00 Uhr" ) zeit = "";

                            return (
                                <TableRow key={row.id}>
                                    <TableCell component="th" scope="row">
                                        {datum}
                                    </TableCell>
                                    <TableCell>{zeit}</TableCell>
                                    <TableCell>{row.place}</TableCell>
                                    <TableCell>{row.title}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Paper>
        );
    }
}



function createEvent(id, start, end, summary, color, place) {
    return {
        id: id,
        start: start,
        end: end,
        title: summary,
        color: color + " !important",
        place: place
    }
}

function parseEvents(ical_raw) {

    let result = [];

    let ical_data = ICAL.parse(ical_raw);
    let vcalendar = new ICAL.Component(ical_data);

    let color = vcalendar.getFirstPropertyValue('x-apple-calendar-color');
    let perish = vcalendar.getFirstPropertyValue('x-wr-calname').split(" ")[0];

    let events = vcalendar.getAllSubcomponents('vevent');


    for (let event_idx in events) {
        let id = events[event_idx].getFirstPropertyValue('uid');
        let start = events[event_idx].getFirstPropertyValue('dtstart').toString();
        let end = events[event_idx].getFirstPropertyValue('dtend').toString();
        let summary = events[event_idx].getFirstPropertyValue('summary');
        let location = events[event_idx].getFirstPropertyValue('location');

        start = moment(start, "YYYY-MM-DD\THH:mm:ss");
        end = moment(end, "YYYY-MM-DD\THH:mm:ss");


        let event = createEvent(id, start, end, summary, color, (location) ? location : perish);
        result.push(event);

    }

    return result;
}


KalenderTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(KalenderTable);
